import React from 'react';

const Footer = ({
  onBrowseHats,
  onUploadHat,
  onMyTrades,
  onHowItWorks,
  onSafetyGuidelines,
  onFAQ
}) => {
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Ooowap</h3>
            <p>
              Connect with fellow purse enthusiasts and trade your favorite bags. 
              Share your style and discover new looks.
            </p>
            <h4>Find us on Socials</h4>
            <div className="social-links">
              <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer'}}><i className="fab fa-facebook"></i></button>
              <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer'}}><i className="fab fa-instagram"></i></button>
              <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer'}}><i className="fab fa-twitter"></i></button>
              <button type="button" style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer'}}><i className="fab fa-discord"></i></button>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home" onClick={(e)=>{e.preventDefault(); window.location.href='/'}}>Home</a></li>
              <li><a href="#browse" onClick={(e)=>{e.preventDefault(); onBrowseHats && onBrowseHats();}}>Browse Purses</a></li>
              <li><a href="#upload" onClick={(e)=>{e.preventDefault(); onUploadHat && onUploadHat();}}>Upload Bag</a></li>
              <li><a href="#trades" onClick={(e)=>{e.preventDefault(); onMyTrades && onMyTrades();}}>My Trades</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Help & Support</h4>
            <ul>
              <li><button type="button" onClick={(e)=>{e.preventDefault(); onHowItWorks && onHowItWorks();}} style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}>How It Works</button></li>
              <li><span className="link-disabled">Safety Guidelines</span></li>
              <li><a href="/faq" style={{color: 'inherit', textDecoration: 'underline'}}>FAQ</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a href="/legal/terms-of-service" style={{color: 'inherit', textDecoration: 'underline'}}>Terms of Service</a></li>
              <li><a href="/legal/privacy-policy" style={{color: 'inherit', textDecoration: 'underline'}}>Privacy Policy</a></li>
              <li><a href="/legal/user-agreement" style={{color: 'inherit', textDecoration: 'underline'}}>User Agreement</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p><i className="fas fa-envelope"></i> contactooowap@gmail.com</p>
            <p><i className="fas fa-map-marker-alt"></i> Ooowap Community</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Ooowap LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 